import React from 'react';
import { Badge, Button, Card, ConfirmDialog, Spinner, useToast } from '../../ui/components';
import { Icon } from '../../ui/icons';
import { useT } from '../../i18n';
import { usersApi } from './usersApi';

export default function RolesTab({ roles, loading, canManage, onEdit, onChanged }) {
  const toast = useToast();
  const t = useT();
  const [confirm, setConfirm] = React.useState(null);
  const [deleting, setDeleting] = React.useState(false);

  const doDelete = async () => {
    setDeleting(true);
    try {
      await usersApi.deleteRole(confirm.id);
      toast.success(t('Role deleted'));
      setConfirm(null);
      onChanged?.();
    } catch (err) {
      toast.error(t('Could not delete role'), { description: err?.message });
    } finally {
      setDeleting(false);
    }
  };

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-6)' }}><Spinner size={24} /></div>;
  }

  return (
    <div className="set-prop-list">
      {roles.map((r) => {
        const count = r.permissions?.includes('*')
          ? t('All permissions')
          : t('{count} permissions', { count: r.permissions?.length ?? 0 });
        return (
          <Card key={r.id} variant="flat">
            <Card.Body>
              <div className="set-prop">
                <div className="set-prop__main">
                  <span className="set-prop__name">
                    {r.name}
                    {r.isSystem ? <Badge tone="neutral">{t('Built-in')}</Badge> : <Badge tone="brand" dot>{t('Custom')}</Badge>}
                  </span>
                  <span className="usr-email">{r.description}</span>
                  <span className="set-prop__meta"><span>{count}</span></span>
                </div>
                <div className="usr-actions">
                  <Button variant="ghost" size="sm" leadingIcon={<Icon.Eye size={15} />} onClick={() => onEdit(r)}>
                    {r.isSystem || !canManage ? t('View') : t('Edit')}
                  </Button>
                  {canManage && !r.isSystem && (
                    <Button variant="ghost" size="sm" leadingIcon={<Icon.Trash size={15} />} onClick={() => setConfirm(r)}>
                      {t('Delete')}
                    </Button>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        );
      })}

      <ConfirmDialog
        open={!!confirm}
        title={t('Delete role')}
        description={confirm ? t('Delete the role "{name}"? This cannot be undone.', { name: confirm.name }) : ''}
        confirmLabel={t('Delete')}
        tone="danger"
        loading={deleting}
        onConfirm={doDelete}
        onCancel={() => (deleting ? null : setConfirm(null))}
      />
    </div>
  );
}
